import { trimObject, mergeDeep, deepCopy } from "@perxis-auto/shared";
import { instanceOfGrid } from "../grid/instanceOfGrid.js";
const DEFAULT_VARS = {
  isExist: false
};
const mergeConstructorItems = (constructorItems, item) => {
  if (!item.id) {
    return constructorItems;
  }
  const mergedConstructorItems = constructorItems.reduce(
    (accumulatedConstructorItems, constructorItem) => {
      if (constructorItem.id === item.id) {
        mergeConstructorItems.vars.isExist = true;
        if (item.isRejected) {
          return accumulatedConstructorItems;
        }
        if (instanceOfGrid(constructorItem) && instanceOfGrid(item)) {
          const { items } = item;
          const overrideItems = items.reduce(mergeConstructorItems.withInsert, [...constructorItem.items]);
          const resolvedGrid = {
            ...constructorItem,
            ...item,
            items: overrideItems
          };
          mergeConstructorItems.vars.isExist = true;
          return [...accumulatedConstructorItems, resolvedGrid];
        }
        return [
          ...accumulatedConstructorItems,
          trimObject(
            mergeDeep({
              ...constructorItem,
              ...item
            })
          )
        ];
      }
      const isGrid = instanceOfGrid(constructorItem);
      if (isGrid) {
        return [
          ...accumulatedConstructorItems,
          {
            ...constructorItem,
            items: mergeConstructorItems(constructorItem.items, item)
          }
        ];
      }
      return [...accumulatedConstructorItems, constructorItem];
    },
    []
  );
  return mergedConstructorItems;
};
mergeConstructorItems.vars = DEFAULT_VARS;
mergeConstructorItems.withInsert = (constructorItems, item) => {
  mergeConstructorItems.vars = deepCopy(DEFAULT_VARS);
  const result = mergeConstructorItems(constructorItems, item);
  if (!mergeConstructorItems.vars.isExist) {
    result.push(item);
  }
  mergeConstructorItems.vars = deepCopy(DEFAULT_VARS);
  return result;
};
function mergeConstructor(defaultConstructor, constructor) {
  if (!constructor) {
    return defaultConstructor;
  }
  const { id, items = [] } = constructor;
  if (id) {
    return constructor;
  }
  const overrideItems = items.reduce(mergeConstructorItems.withInsert, [...defaultConstructor.items]);
  return {
    ...defaultConstructor,
    ...constructor,
    items: overrideItems
  };
}
export {
  mergeConstructor
};
